var cpApplyForm = cpApplyForm || {};
(function (obj) {
    var form = jQuery('#applyForm');
    var regionSelect = jQuery('.js-example-basic-single-parent');
    var regionInput = jQuery('input[name="region"]');
    var defaultRegionIdField = jQuery('input[name="defaultRegionId"');
    var defaultRegionNameField = jQuery('input[name="defaultRegionName"');
    var defaultRoleField = jQuery('input[name="defaultRole"');
    var defaultRegionId = '';
    var defaultRegionName = '';
    var defaultRole = '';
    var regionSelectInstance = undefined;
    var name_subject = 'subject';
    var id_recaptchaResp = '#g-recaptcha-response';
    var cls_recaptchaError = 'js-rc-error';
    var cls_formError = 'cp-form__error';
    var cls_input = 'cp-input';

    var regionDataAttr = 'data-region';
    var featuredCategoryId = 245;
    var rcErrorString = '<span>Please, check the ReCaptcha box.</span>';

    var regionId = undefined;
    var regionName = '';
    var role = '';

    var validator = function () {
        jQuery.validator.addMethod('filesize', function (value, element, param) {
            return this.optional(element) || (element.files[0].size <= param * 1024 * 1024)
        }, 'File size should be less than {0}MB');

        form.validate({
            rules: {
                input_file: {
                    required: true,
                    extension: 'pdf|doc|docx|rtf|txt',
                    filesize: 2
                },
            },
            errorElement: 'span',
            errorPlacement: function (error, element) {
                let target = element.closest('.' + cls_input);
                target.find('.' + cls_formError).append(error);
            },
            submitHandler: function (form) {
                if (jQuery(id_recaptchaResp).length && jQuery(id_recaptchaResp).val().length > 0) {
                    jQuery('.' + cls_recaptchaError).html('');
                    form.submit();
                } else {
                    jQuery('.' + cls_recaptchaError).html(rcErrorString);
                }
            }
        });
    }

    var setSubjectField = function () {
        var subject = 'Application - ' + regionName + ' - ' + role;
        var subjectField = form.find('input[name="' + name_subject + '"]');

        if (setSubjectField) {
            subjectField.val(subject);
        }
    }

    var initSelect2 = function () {
        regionSelectInstance = jQuery('.js-example-basic-single').select2({
            theme: 'flat',
            dropdownParent: jQuery('.js-example-basic-single-parent'),
            width: '100%',
            placeholder: 'Select your region',
        });
        regionSelectInstance.on('select2:select', function (e) {
            var text = e.params.data.text;
            console.log(text);
            regionName = text;
            regionInput.val(regionName);
            setSubjectField();
        });
    }

    var setSelectedRegion = function () {
        if (!regionSelect || !regionSelectInstance) {
            return;
        }

        var options = regionSelect.find('option');

        if (!options) {
            return;
        }

        options.each(function () {
            var el = jQuery(this);
            var region = el.attr(regionDataAttr);
            if (regionId === region) {
                if (regionSelectInstance.hasClass('select2-hidden-accessible')) {
                    var value = el.val();
                    regionSelectInstance.val(value).trigger('change');
                    regionName = regionSelectInstance.val();
                    regionSelect.find('option[value="' + regionName + '"]').attr('selected', 'selected');
                    regionInput.val(regionName);
                    regionSelectInstance.prop('disabled', true);
                }
            }
        });
    }

    var setDefaultValues = function () {
        defaultRegionId = defaultRegionIdField.val() || '';
        defaultRegionName = defaultRegionNameField.val() || '';
        defaultRole = defaultRoleField.val() || '';
        regionId = defaultRegionId;
        regionName = defaultRegionName;
        role = defaultRole;

        if (parseInt(regionId, 10) !== featuredCategoryId) {
            setSelectedRegion();
        }
    }

    obj.init = function () {
        if (!form) {
            return;
        }
        validator();
        initSelect2();
        setDefaultValues();
        setSubjectField();
    }
})(cpApplyForm);